import type {
  InsightsRecipeCreate,
  InsightsRecipeDetail,
  InsightsRecipeList,
} from "schemas/generated/bedrockApi/insightsRecipes";
import type { RequestFn } from "./request";

export function createInsightsRecipesClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    find: ({
      workspaceId,
      offset = 0,
    }: {
      workspaceId: string;
      offset?: number;
    }) => {
      return request<InsightsRecipeList>({
        method: "GET",
        path: `/api/v1/insights-recipes?workspaceId=${encodeURIComponent(workspaceId)}&offset=${offset}`,
      });
    },
    get: ({
      workspaceId,
      recipeId,
    }: {
      workspaceId: string;
      recipeId: string;
    }) => {
      return request<InsightsRecipeDetail>({
        method: "GET",
        path: `/api/v1/insights-recipes/${encodeURIComponent(recipeId)}?workspaceId=${encodeURIComponent(workspaceId)}`,
      });
    },
    create: (body: InsightsRecipeCreate) => {
      return request<InsightsRecipeDetail>({
        method: "POST",
        path: "/api/v1/insights-recipes",
        body,
      });
    },
    delete: ({
      workspaceId,
      recipeId,
    }: {
      workspaceId: string;
      recipeId: string;
    }) => {
      return request<{ ok: true }>({
        method: "DELETE",
        path: `/api/v1/insights-recipes/${encodeURIComponent(recipeId)}?workspaceId=${encodeURIComponent(workspaceId)}`,
      });
    },
  };
}
